import { render } from "./GdprView.vue?vue&type=template&id=ef607c34"
import script from "./GdprView.vue?vue&type=script&lang=js"
export * from "./GdprView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__